module.exports = __webpack_public_path__ + "img/instagram-white.74e2ede9.svg";